module.exports = __webpack_public_path__ + "static/TACO1-535c0a423d19334fbc2a2b1d7a3c85b1.jpg";